<template>
  <div style="padding:10px 20px;">
    <div class="display_flex_center" style="justify-content: space-between;">
      <div style="display: flex;align-items: center;">

        <div class="card_top" v-if="addtype" style="background: #4E66FF; color: #fff;margin-right: 10px;">
          <el-button size="small" type="text" @click="btnlistOut(10)">
            <span style="color: #fff;"><i class="iconfont icon-xinzeng" style="color: #fff;"></i> 创建文件夹</span>
          </el-button>
        </div>
        <div class="card_top" v-if="type == 1">
          <el-button size="small" type="text" @click="btnlistOut(0)" v-if="femxiang">
            <span style=" color: #4E66FF;"><i class="iconfont icon-fenxiang1" style=" color: #4E66FF;"></i> 分享</span>
          </el-button>
          <el-button size="small" type="text" @click="btnlistOut(1)" v-if="xiazai">
            <span style=" color: #4E66FF;"><i class="iconfont icon-xiazai1" style=" color: #4E66FF;"></i> 下载</span>
          </el-button>
          <el-button size="small" type="text" @click="btnlistOut(2)" v-if="sctype">
            <span style=" color: #4E66FF;"><i class="iconfont icon-shoucang" style=" color: #4E66FF;"></i> 收藏</span>
          </el-button>
          <el-button size="small" type="text" @click="btnlistOut(3)" v-if="deltype">
            <span style=" color: #4E66FF;"><i class="iconfont icon-shanchu1" style=" color: #4E66FF;"></i> 删除</span>
          </el-button>
        </div>

        <div class="card_top" v-if="type == 2">
          <el-button size="small" type="text" @click="btnlistOut(3)" v-if="deltype">
            <span style=" color: #4E66FF;"><i class="iconfont icon-shanchu1" style=" color: #4E66FF;"></i> 取消分享</span>
          </el-button>
          <el-button size="small" type="text" @click="btnlistOut(0)" v-if="femxiang">
            <span style=" color: #4E66FF;"><i class="iconfont icon-fenxiang1" style=" color: #4E66FF;"></i> 分享</span>
          </el-button>
          <el-button size="small" type="text" @click="btnlistOut(1)" v-if="xiazai">
            <span style=" color: #4E66FF;"><i class="iconfont icon-xiazai1" style=" color: #4E66FF;"></i> 下载</span>
          </el-button>
        </div>
        <div style="margin-left: 10px;">
          <slot name="search"></slot>
        </div>
      </div>
      <div v-if="showistrue">
        <i style="font-size: 18px;margin-left: 10px;cursor: pointer;color: #C4C4C4;" @click="elswitchstatus"
          class="iconfont" :class="$store.state.istrue ? 'icon-shitu-kapianliebiao' : 'icon-shitu-kapian'"></i>
      </div>
      <div v-else>
        <slot name="btn_right"></slot>
      </div>
    </div>
    <!-- <div style="padding:10px 0 0 0px;color: #383838;font-size: 14px;font-weight: 700;">全部文件</div> -->
  </div>
</template>
<script>
export default {
  props: {
    addtype: {
      type: Boolean,
      default: () => false,
    },
    sctype: {
      type: Boolean,
      default: () => false,
    },
    deltype: {
      type: Boolean,
      default: () => false,
    },
    // 是否多选
    type: {
      type: Number,
      default: 1,
    },
    showistrue: {
      type: Boolean,
      default: () => true,
    },
    xiazai: {
      type: Boolean,
      default: () => true,
    },
    femxiang: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  computed: {

  },
  methods: {
    // 切换卡片状态
    elswitchstatus() {
      this.$emit("elswitchstatus")
      this.$store.commit("SET_Istrue", !this.$store.state.istrue)
    },
    // 按钮提交
    btnlistOut(val) {
      this.$emit("btnlistOut", val)
    }

  },
}
</script>
<style lang='less' scoped>
.el-button--text {
  font-size: 14px !important;
}

.card_top {
  // width: 300px;
  padding: 0px 20px;
  height: 40px;
  font-size: 14px;
  border-radius: 30px;
  display: block;
  background-color: rgba(78, 102, 255, 0.1);
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .el-button {
    padding: 0 10px !important;
  }
}
</style>
